// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"launchInfo_cardBody__1G7jd","top":"launchInfo_top__3M-zr","date":"launchInfo_date__1aA6w","number":"launchInfo_number__14yr-","info":"launchInfo_info__1KGwz"};